"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteLineItemWidget = void 0;
var react_1 = __importDefault(require("react"));
var QuoteLineItemContext_1 = require("./QuoteLineItemContext");
var styles = __importStar(require("./QuoteLineItemWidget.css"));
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var QuoteLineItemWidget = function (_a) {
    var attributes = _a.attributes, children = _a.children;
    var _b = (0, QuoteLineItemContext_1.useQuoteLineItemContext)(), components = _b.components, item = _b.item, actions = _b.actions, id = _b.id;
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)(attributes.className, styles.wrapper) }),
        react_1.default.createElement("div", { contentEditable: false },
            react_1.default.createElement("div", null, "Quote Line Item"),
            components.OptionsMenu && (react_1.default.createElement("div", { "data-interactive-zone": true, className: styles.options },
                react_1.default.createElement(components.OptionsMenu, null)))),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s" },
            item.selection.mode === "optional" && (react_1.default.createElement("div", { "data-interactive-zone": true },
                react_1.default.createElement(kaleidoscope_1.Checkbox, { checked: item.selection.selected, labelHidden: true, role: item.selection.singleSelect ? "radio" : undefined, id: "line-item-".concat(id, "-selected"), label: "Select line item", size: "m", onChange: function () {
                        actions.toggleItemSelected();
                    } }))),
            react_1.default.createElement("div", { className: styles.descriptionWrapper }, children))));
};
exports.QuoteLineItemWidget = QuoteLineItemWidget;
